import React, { createContext, useContext, useState } from "react";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";
const translations = {
  en: en,
  ru: ru,
  uk: uk
};
export function translate(key, lang = "en") {
  return translations[lang][key];
}
export const TranslateContext = /*#__PURE__*/createContext(null);
export function TranslateProvider({
  children
}) {
  let [language, setLanguage] = useState("en");

  const _t = key => translate(key, language);

  let value = {
    _t,
    language,
    setLanguage
  };
  return /*#__PURE__*/React.createElement(TranslateContext.Provider, {
    value: value
  }, children);
}
export function useTranslation() {
  return useContext(TranslateContext);
}